import React from "react";

// Table pattern from ADMIN_DESIGN_SYSTEM.md: wrapper rounds/clips the head,
// hover only on mutable/actionable tables (pass hover=false for read-only
// report tables — e.g. Analytics' pass-rate table), uniform px-4 py-3 cells,
// Actions column right-aligned via col.align.
export function AdminTable({ columns, children, testId }) {
  return (
    <div className="rounded-2xl bg-white border border-[#E5DFC8] overflow-hidden" data-testid={testId}>
      <div className="overflow-x-auto">
        {/* min-w so the table can't shrink-to-fit and silently cram/hide
            columns on a narrow screen — w-full alone never triggers this
            wrapper's overflow-x-auto, since the table just obeys it and
            squeezes every column instead of overflowing. */}
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="bg-hv-cream text-hv-slate text-left">
              {columns.map((col) => (
                <th
                  key={col.key}
                  className={`px-4 py-3 text-[11px] font-bold uppercase tracking-wider ${col.align === "right" ? "text-right" : "text-start"}`}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5DFC8]">{children}</tbody>
        </table>
      </div>
    </div>
  );
}

export function AdminTableRow({ hover = true, selected, className = "", children, ...props }) {
  return (
    <tr {...props} className={`${hover ? "hover:bg-hv-cream/60" : ""} ${selected ? "bg-hv-tealTint" : ""} ${className}`}>
      {children}
    </tr>
  );
}

export function AdminTableCell({ align, className = "", children }) {
  return <td className={`px-4 py-3 align-top ${align === "right" ? "text-end" : ""} ${className}`}>{children}</td>;
}

export function AdminTableMessageRow({ colSpan, children }) {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-10 text-hv-slate text-sm">
        {children}
      </td>
    </tr>
  );
}
